<template>
  <v-app id="inspire" class="fndTecisa" v-bind:style="{ backgroundImage: 'url(' + bgImage + ')' }">
    <img id="logoTecisa" src="/assets/logoTecisaBn.png" />
    <v-content>
      <transition name="page" mode="out-in">
        <router-view :key="$route.fullPath" />
      </transition>
    </v-content>
  </v-app>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import CustomToolbar from "@/components/layout/toolbar";

export default {
  components: {
    CustomToolbar
  },
  computed: {
    ...mapState("global", ["drawer", "mini"]),
    ...mapState("global", ["conexionApi"]),
    bgImage: function() {
      return this.$store.state.global.rootPath + "/assets/fndTecisa.jpg";
    }
  },
  data() {
    return {
      dialog: false,
      fab_hidden: false
    };
  },
  watch: {
    conexionApi: function(val) {
      if (!val) {
        this.$router.push("/error-conexion");
      }
    }
  },
  mounted() {
    //si no me estoy conectando a la api y no hay conexión, enviamos a la página de error
    if (
      !this.$store.state.global.conectandoApi &&
      !this.$store.state.global.conexionApi
    ) {
      this.$router.push("/error-conexion");
    }
  },
  methods: {
    ...mapMutations("global", ["SET_DRAWER", "SET_MINI"]),
    toggleDrawer: function(visible) {
      this.SET_DRAWER(visible);
    },
    toggleMini: function() {
      this.SET_MINI({
        mini: !this.mini,
        lgAndUp: this.$vuetify.breakpoint.lgAndUp
      });
    },
    mostrarOcultarMenu: function(lgUp) {
      let that = this;
      if (lgUp) {
        that.mini = !that.mini;
        that.SET_DRAWER(true);
      } else {
        that.mini = null;
        let visible = !that.drawer;
        that.SET_DRAWER(visible);
      }
    }
  }
};
</script>
<style scoped>
.fndTecisa >>> {
  background-size: cover !important;
  background-position: center !important;
}
#logoTecisa {
  position: absolute;
  top: 15px;
  left: 25px;
  height: 45px;
}
</style>